import { Card, Row, Col, Button, Badge, Progress, Alert, Typography } from "antd"
import {
  BellOutlined,
} from "@ant-design/icons"
const { Title, Text } = Typography


const FinancialAlerts = () => {
  return (
    <Row gutter={[24, 24]}>
          {/* Uncaptured Opportunity Alert */}
          <Col xs={24} lg={12}>
            <Card>
              <Title level={4}>
                <BellOutlined style={{ marginRight: "8px" }} />
                Uncaptured Opportunity Alert
              </Title>
              <Text type="secondary">Auto-detects signals Radar flagged but you ignored or delayed</Text>

              <div style={{ marginTop: "16px" }}>
                <Alert
                  message="Missed Growth Opportunity"
                  description={
                    <div>
                      <div>GTM Signal in LatAm → Est. $480K unclaimed</div>
                      <Text type="secondary" style={{ fontSize: "12px" }}>
                        Flagged 15 days ago
                      </Text>
                    </div>
                  }
                  type="warning"
                  action={
                    <Button type="primary" danger size="small">
                      Re-activate Strategy
                    </Button>
                  }
                  style={{ marginBottom: "16px" }}
                />

                <Alert
                  message="Technology Investment"
                  description={
                    <div>
                      <div>AI Automation Signal → Est. $320K efficiency gain</div>
                      <Text type="secondary" style={{ fontSize: "12px" }}>
                        Flagged 8 days ago
                      </Text>
                    </div>
                  }
                  type="info"
                  action={<Button size="small">Review</Button>}
                />
              </div>
            </Card>
          </Col>

          {/* Objective Alignment View */}
          <Col xs={24} lg={12}>
            <Card>
              <Title level={4}>Objective Alignment View</Title>
              <Text type="secondary">Connects top-line company objectives to financial performance and signals</Text>

              <div style={{ marginTop: "16px" }}>
                <Card size="small" style={{ marginBottom: "16px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "12px",
                    }}
                  >
                    <Text strong>Objective: Expand to Asia</Text>
                    <Badge color="orange" text="Q3 2024" />
                  </div>

                  <div style={{ marginBottom: "12px" }}>
                    <div style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
                      <div
                        style={{
                          width: "8px",
                          height: "8px",
                          backgroundColor: "#ff4d4f",
                          borderRadius: "50%",
                          marginRight: "8px",
                        }}
                      />
                      <Text style={{ fontSize: "14px" }}>Risk: Import costs ↑</Text>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div
                        style={{
                          width: "8px",
                          height: "8px",
                          backgroundColor: "#ff4d4f",
                          borderRadius: "50%",
                          marginRight: "8px",
                        }}
                      />
                      <Text style={{ fontSize: "14px" }}>Risk: Talent shortage</Text>
                    </div>
                  </div>

                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                    <Text strong style={{ fontSize: "14px" }}>
                      Impact:
                    </Text>
                    <Text strong style={{ color: "#ff4d4f" }}>
                      -$240K unaddressed drag
                    </Text>
                  </div>

                  <Progress percent={35} status="exception" />
                  <Text type="secondary" style={{ fontSize: "12px" }}>
                    35% completion risk due to unmitigated factors
                  </Text>
                </Card>

                <Card size="small">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "12px",
                    }}
                  >
                    <Text strong>Objective: Reduce OpEx by 15%</Text>
                    <Badge color="green" text="On Track" />
                  </div>

                  <div style={{ marginBottom: "12px" }}>
                    <div style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
                      <div
                        style={{
                          width: "8px",
                          height: "8px",
                          backgroundColor: "#52c41a",
                          borderRadius: "50%",
                          marginRight: "8px",
                        }}
                      />
                      <Text style={{ fontSize: "14px" }}>Opportunity: Process automation</Text>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div
                        style={{
                          width: "8px",
                          height: "8px",
                          backgroundColor: "#52c41a",
                          borderRadius: "50%",
                          marginRight: "8px",
                        }}
                      />
                      <Text style={{ fontSize: "14px" }}>Opportunity: Vendor renegotiation</Text>
                    </div>
                  </div>

                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                    <Text strong style={{ fontSize: "14px" }}>
                      Impact:
                    </Text>
                    <Text strong style={{ color: "#52c41a" }}>
                      +$420K potential savings
                    </Text>
                  </div>

                  <Progress percent={78} />
                  <Text type="secondary" style={{ fontSize: "12px" }}>
                    78% completion probability
                  </Text>
                </Card>
              </div>
            </Card>
          </Col>
        </Row>
  )
}

export default FinancialAlerts